const scrapingTestCaseTagsFormRules = {
  tagIds: [
    {
      required: true,
      type: 'array',
      message: 'Please provide at least one free text tag',
    },
  ],
}

export default scrapingTestCaseTagsFormRules
